__turbopack_context__.v({
  "comment-container": "ReviewComment-module-scss-module__1dAcaq__comment-container",
  "comment-info": "ReviewComment-module-scss-module__1dAcaq__comment-info",
  "comment-name": "ReviewComment-module-scss-module__1dAcaq__comment-name",
  "comment-rating": "ReviewComment-module-scss-module__1dAcaq__comment-rating",
  "comment-review": "ReviewComment-module-scss-module__1dAcaq__comment-review",
});
